import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { Editor, NgxEditorModule, Toolbar, TOOLBAR_MINIMAL } from 'ngx-editor';
import { skip } from 'rxjs';
import { ProseMirrorEditorService } from 'src/app/services/prose-mirror-editor.service';


export type EditorType = "basic" | "emailTemplate" | "minimal" | "customerNote" | "main-site-content" | "alert"

@Component({
  selector: 'app-prose-mirror',
  templateUrl: './prose-mirror.component.html',
  styleUrls: ['./prose-mirror.component.scss'],
  standalone: true,
  imports: [NgxEditorModule, NgClass, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProseMirrorComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ProseMirrorComponent
    }
  ]
})
export class ProseMirrorComponent implements OnInit, ControlValueAccessor, Validator {



  @Input() editorType: EditorType = "basic"
  editor: Editor = this.proseMirrorService.getBasicEditor()
  toolbar: Toolbar = []

  writtenValue: string = ""
  htmlContent: string = ""

  onChange: any = () => { }
  onTouched: any = () => { }
  onValidatorChange: any = () => { }
  disabled = false
  touched = false
  class = ""


  @Output() valueChanges = new EventEmitter<Record<string, any>>

  constructor(
    private proseMirrorService: ProseMirrorEditorService
  ) {

  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    return null
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn
  }

  ngOnInit(): void {

    switch (this.editorType) {
      case "basic":
        this.editor = this.proseMirrorService.getBasicEditor()
        this.toolbar = TOOLBAR_MINIMAL
        break
      case "emailTemplate":
        this.editor = this.proseMirrorService.getEmailTemplateEditor()
        this.toolbar = this.proseMirrorService.getEmailTemplateToolbar()
        break
      case "minimal":
        this.editor = this.proseMirrorService.getMinimalEditor()
        this.toolbar = this.proseMirrorService.getMinimalToolbar()
        break
      case "customerNote":
        this.editor = this.proseMirrorService.getCustomerNoteEditor()
        this.toolbar = this.proseMirrorService.getCustomerNoteToolbar()
        break
      case "main-site-content":
        this.editor = this.proseMirrorService.getMainSiteContentEditor()
        this.toolbar = this.proseMirrorService.getMainSiteContentToolbar()
        break
      case "alert":
        this.editor = this.proseMirrorService.getAlertEditor()
        this.toolbar = this.proseMirrorService.getAlertToolbar()
        break

    }


    this.editor.valueChanges.subscribe((changes) => {
      this.valueChanges.emit(changes)
    })

  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  writeValue(value: string): void {

      this.writtenValue = value ?? ""
      this.htmlContent = value ?? ""

  }

  valueChange() {
    //Skip the change if the value passed through ngmodel/reactive forms writeValue is the same as from this event.
    //This was to prevent consulting forms from immediately getting a change event and saving during the initial load.
    //This assumes the caller doesn't want to be notified of its own changes to the model/form
    if (this.writtenValue !== this.htmlContent) {
      this.onChange(this.htmlContent)
    }
   
  }

  onInputBlur() {
    this.markAsTouched()
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true

    }
  }

}
